import { SET_FILTER_LIST_PENOMORAN, UPDATE_DATATABLE_COLUMN, UPDATE_DATATABLE_ROW ,UPDATE_LAST_PAGE_DATATABLE, UPDATE_LAST_SEARCH_DATATABLE} from "shared/constants/ActionTypes";

export const updateColumns = (columns) => ({
    type: UPDATE_DATATABLE_COLUMN,
    payload: columns,
  });
  
  export const updateRows = (rows) => ({
    type: UPDATE_DATATABLE_ROW,
    payload: rows,
  });

  export const updateTableInfo = (info) => ({
    type: UPDATE_DATATABLE_TABLE_INFO,
    payload: info,
  });

  export const updateLastPageNo = (pageNo) => ({
    type: UPDATE_LAST_PAGE_DATATABLE,
    payload: pageNo,
  });

  export const updateLastPageSearch = (pageSearch) => ({
    type: UPDATE_LAST_SEARCH_DATATABLE,
    payload: pageSearch,
  });

  export const setFilterListPenomoran = (url) => ({
    type: SET_FILTER_LIST_PENOMORAN,
    payload: url,
  });


